// Maps backend `aiName` (model brand) → council persona display
// Backend renvoie : Claude / GPT-4 / GPT-5 / Gemini / Mistral / Perplexity / DeepSeek / Cohere / Imani

export type CouncilPersonaId =
  | "delphine"
  | "henri"
  | "akilah"
  | "eva"
  | "ren"
  | "julien"
  | "imani";

export interface CouncilPersonaDisplay {
  persona: CouncilPersonaId | null;
  name: string; // "Delphine" / "Conseil" si inconnu
  modelLabel: string; // libellé de la famille active / "" si inconnu
}

const AI_NAME_TO_PERSONA: Array<{
  match: (s: string) => boolean;
  persona: CouncilPersonaId;
  name: string;
  modelLabel: string;
}> = [
  {
    match: (s) => s.includes("claude") || s === "anthropic",
    persona: "delphine",
    name: "Delphine",
    modelLabel: "Claude Sonnet 4.6 / Opus 4.8",
  },
  {
    match: (s) => s.includes("gpt") || s.includes("openai"),
    persona: "henri",
    name: "Henri",
    modelLabel: "GPT-5.4 mini / GPT-5.5",
  },
  {
    match: (s) => s.includes("gemini") || s.includes("google"),
    persona: "akilah",
    name: "Akilah",
    modelLabel: "Gemini 3.5 Flash",
  },
  {
    match: (s) => s.includes("mistral"),
    persona: "eva",
    name: "Eva",
    modelLabel: "Mistral Small / Large",
  },
  {
    match: (s) => s.includes("perplexity") || s.includes("sonar"),
    persona: "julien",
    name: "Julien",
    modelLabel: "Sonar / Sonar Pro",
  },
  {
    match: (s) => s.includes("deepseek"),
    persona: "ren",
    name: "Ren",
    modelLabel: "DeepSeek V4 Flash",
  },
  {
    match: (s) => s.includes("imani") || s.includes("cohere") || s.includes("command"),
    persona: "imani",
    name: "Imani",
    modelLabel: "Cohere Command A",
  },
];

export function aiNameToPersonaDisplay(
  raw: string | null | undefined,
): CouncilPersonaDisplay {
  if (!raw) return { persona: null, name: "Conseil", modelLabel: "" };
  const s = raw.toLowerCase().trim();
  const entry = AI_NAME_TO_PERSONA.find((e) => e.match(s));
  if (!entry) return { persona: null, name: "Conseil", modelLabel: "" };
  return {
    persona: entry.persona,
    name: entry.name,
    modelLabel: entry.modelLabel,
  };
}

/**
 * Convertit un display name de conseiller ("Imani", "Delphine", …)
 * en clé de persona stable ("imani", "delphine", …).
 * Renvoie `null` si non reconnu.
 */
export function displayNameToKey(
  name: string | null | undefined,
): CouncilPersonaId | null {
  return aiNameToPersonaDisplay(name).persona;
}
